import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { SupportedFunctions, useEventFunctions } from '../../../../../../../../hooks/useEventFunctions';
import { useSelector } from '../../../../../../../../reduxToolkit/typedRedux';
import VyTooltip from '../../../../../../../common/VyTooltip';

export const StreamTypeSelect = ({ defaultValue }: { defaultValue?: 'livestream' | 'videoconference' }) => {
  const { control } = useFormContext();
  const { isFunctionEnabled } = useEventFunctions();
  const event = useSelector((state) => state.common.event);

  const { t } = useTranslation('event');

  return (
    <Controller
      control={control}
      rules={{ required: true }}
      defaultValue={defaultValue ?? 'videoconference'}
      name="videoType"
      render={({ field: { onChange, value } }) => (
        <FormControl>
          <FormLabel id="demo-row-radio-buttons-group-label">{t('presentation.videotype')}</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={value}
            onChange={(_, value) => onChange(value)}>
            {isFunctionEnabled(SupportedFunctions.livestreams, event) && (
              <VyTooltip title={t('presentation.livestream-videotype-tooltip')}>
                <FormControlLabel value="livestream" control={<Radio />} label={t('presentation.livestream-videotype')} />
              </VyTooltip>
            )}
            {isFunctionEnabled(SupportedFunctions.videomeet, event) && (
              <VyTooltip title={t('presentation.conference-videotype-tooltip')}>
                <FormControlLabel value="videoconference" control={<Radio />} label={t('presentation.conference-videotype')} />
              </VyTooltip>
            )}
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};
